import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { HrtApiService } from '../hrt-api/hrt-api.service';
import {
  FetchOHistMetadataParams,
  mapOHistMetadataDtoToModel,
  OhistApiPayload,
  OHistMetadata,
  OHistMetadataDto,
} from '@brc/shared/models/ohist-report.model';

@Injectable({
  providedIn: 'root',
})
export class OHistReportApiService {
  readonly ohistMetadataUrl = (machineId: number) => `machines/${machineId}`;
  readonly api = inject(HrtApiService);

  fetchOHistMetadata({ machines }: FetchOHistMetadataParams): Observable<OHistMetadata[]> {
    return this.api
      .getForOrganization<OHistMetadataDto[]>('ohistmetadata', {
        params: {
          machines,
        },
      })
      .pipe(
        map((ohistmetadata) => {
          return ohistmetadata.map(mapOHistMetadataDtoToModel);
        }),
        catchError(() => of([]))
      );
  }

  generateOHistReport(apiPayload: OhistApiPayload): Observable<OhistApiPayload> {
    return this.api.postForOrganization<OhistApiPayload>(`ohistreport/generate`, apiPayload);
  }
}
